import { Link } from 'react-router-dom';
import { Button } from '../ui/Button';
import { SealBadge } from '../ui/SealBadge';
import { HeroCarousel } from './HeroCarousel';

export function HeroSection() {
  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-paper via-paper to-seal-blue/5">
      {/* Large soft color washes so the hero reads as more than flat
          white — subtle, kept behind the content via z-index/opacity. */}
      <div className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-marigold/10 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-24 -right-16 h-80 w-80 rounded-full bg-seal-blue/10 blur-3xl" />

      <div className="relative mx-auto grid max-w-6xl grid-cols-1 items-center gap-12 px-4 py-16 sm:px-6 md:grid-cols-2 md:py-24">
        <div className="animate-fade-up">
          <p className="font-mono text-xs uppercase tracking-widest text-ledger-green">
            India&apos;s Trusted Tax, Legal &amp; Business Compliance Partner
          </p>
          <h1 className="mt-3 font-display text-4xl font-bold leading-[1.1] text-ink sm:text-5xl">
            Start &amp; Grow Your Business with
            <br />
            India&apos;s Trusted <span className="text-seal-blue">Tax &amp; Legal Experts</span>
          </h1>
          <p className="mt-5 max-w-md text-lg text-ink/70">
            Bharat Consultancy provides end-to-end GST, Income Tax, EPFO, ESIC, Project Reports, Licenses,
            Accounting, Legal Documentation and Financial Consultancy services, Business Registration, and Company
            Compliance across India. From startups to established businesses — we make legal and tax compliance
            simple, affordable, and completely online.
          </p>
          {/*
            NOTE: the client's shared content doc uses "Get Free
            Consultation" as the primary CTA label. The site's actual
            consultation flow charges ₹499 (see ConsultCTA.tsx / the
            consultation booking system) — labeling this button "free"
            would misrepresent what happens at checkout, so it's kept
            accurate to the real flow instead. Flag this wording
            conflict to the client; if they want a genuinely free
            initial call, that's a product/pricing decision, not just a
            copy change.
          */}
          <div className="mt-8 flex flex-wrap gap-4">
            <Link to="/consult">
              <Button size="lg" variant="accent">
                Book a Consultation
              </Button>
            </Link>
            <Link to="/services">
              <Button size="lg">Apply Online</Button>
            </Link>
            <a href="https://wa.me/918170896296" target="_blank" rel="noreferrer">
              <Button size="lg" variant="outline">
                WhatsApp Now
              </Button>
            </a>
          </div>
        </div>

        <div className="relative flex items-center justify-center py-6">
          <HeroCarousel />
          <div className="pointer-events-none absolute -right-2 -top-4 animate-stamp-down sm:right-2 sm:top-0">
            <SealBadge size="sm">
              <span className="block text-base">✓</span>
              Filed &amp;
              <br />
              Approved
            </SealBadge>
          </div>
        </div>
      </div>
    </section>
  );
}
